import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Landused, Land } from 'src/app/_models/land.model';
import { HttpService } from 'src/app/_services';
import swal from 'sweetalert2';
import { OwnerDetail } from 'src/app/_models/owner.model';
import { Building } from 'src/app/_models/building.model';


@Component({
  selector: 'app-land-used',
  templateUrl: './land-used.component.html',
  styleUrls: ['./land-used.component.scss']
})
export class LandUsedComponent implements OnInit {

  @ViewChild('building') templateRefBuilding: TemplateRef<any>;

  landused: Landused;
  @Input() diffArea;
  @Input() luid;
  @Input() public land: Land;
  @Input() public ownerList: OwnerDetail[];

  gridApi: any;
  gridColumnApi: any;
  maxArea: number;

  buildingColumn = [
    { headerName: 'ลำดับ', field: 'no', width: 50 },
    { headerName: 'เลขที่', field: 'address', width: 50 },
    { headerName: 'ประเภทสิ่งปลูกสร้าง', field: 'building_type', width: 200 },
    { headerName: 'ห้อง', field: 'room', width: 50 },
    { headerName: 'ชั้น', field: 'floor', width: 50 },
    { headerName: 'ขนาดพื้นที่ ที่ใช้สร้างสิ่งปลูกสร้าง(ตร.ม) (ชั้นที่ 1)', field: 'area', width: 200 },
  ];

  buildingRow = [];
  diffArea2: number;


  constructor(
    public activeModal: NgbActiveModal,
    private http: HttpService,
    private modalService: NgbModal
  ) { }

  getData() {
    this.http.requestGet("lands/lu/" + this.luid).subscribe(
      res => {
        this.landused = res.lu;
        this.buildingRow = res.buildings;
        let b_area=0;
        if(this.buildingRow.length >0){
          b_area = this.buildingRow[0].area;
        }
        const used_area = (Number(this.landused.u_r) * 1600) + (Number(this.landused.u_y) * 400) + (Number(this.landused.u_w) * 4);
        if (this.landused.lu_type == 5) {
          if (used_area < b_area) {
            swal("ขนาดพื้นที่การใช้ประโยชน์ มีขนาดน้อยกว่าพื้นที่ปลูกอาคาร");
          } else {
            this.diffArea2 = (used_area - b_area) / 4;
            console.log(this.diffArea2);
            if (this.diffArea2 > 0) {
              swal("ขนาดพื้นที่ใช้ประโยชน์หลายประเภทควรจะเท่ากับ " + (b_area / 4) + " ตร.ว.")
            }
          }

          if (this.diffArea == 0) {
            this.diffArea = used_area;
          } else {
            this.diffArea = this.diffArea + used_area;
          }
        }else{
          if (used_area < b_area) {
            swal("ขนาดพื้นที่การใช้ประโยชน์ มีขนาดน้อยกว่าพื้นที่ปลูกอาคาร");
          } else {
            this.diffArea2 = (used_area - b_area) / 4;
            console.log("CASE LUTYPE =2 "+this.diffArea2);
          }

          if (this.diffArea == 0) {
            this.diffArea = used_area;
          } else {
            this.diffArea = this.diffArea + used_area;
          }
        }
      }

    );
  }

  ngOnInit() {
    if (this.luid != undefined) {
      //get data from server
      this.landused = new Landused();
      setTimeout((v) => { this.getData() });
    } else {
      this.convertArea();
    }
  }

  convertArea() {
    let rai = Math.floor(this.diffArea / 1600);
    let yawn = Math.floor((this.diffArea % 1600) / 400);
    let findSubwa = (((this.diffArea % 1600) % 400) % 4);
    let wa = 0;
    if (findSubwa > 0) {
      wa = Number((((this.diffArea % 1600) % 400) / 4).toPrecision(4));
    } else {
      wa = (((this.diffArea % 1600) % 400) / 4);

    }
    this.landused.u_r = rai.toString();
    this.landused.u_y = yawn.toString();
    this.landused.u_w = wa.toString();
  }

  callArea() {
    // console.log('Diff Area : ' + this.diffArea);
    const used_area = (Number(this.landused.u_r) * 1600) + (Number(this.landused.u_y) * 400) + (Number(this.landused.u_w) * 4);
    if (used_area > this.diffArea) {
      swal("กรอกเนื้อที่การใช้ประโยชน์ เกินขนาดที่เหลือ");
      this.convertArea();
      return;
    }
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  createBuilding() {
    if (this.landused.lu_type == 5) {
      if (this.buildingRow.length == 0) {
        //  const modalRef2 = this.modalService.open(BuildingFormComponent, { windowClass: 'fullscreen' });
        const modalRef2 = this.modalService.open(this.templateRefBuilding, { windowClass: 'fullscreen' });
        // console.log(this.ownerList);
        // let building = new Building();
        // building.annual = this.land.annual;
        // building.oid = this.ownerList[0].landOwner.owner_id;
        // building.moo = this.land.moo;
        // building.village = this.land.community;
        // building.ref_luid = this.landused.luid;
        // building.ref_lid = this.land.lid;
        // building.parcel_code = this.land.parcel_code;
        // modalRef2.componentInstance.inputBuilding = building;

        modalRef2.result.then((data) => {
          // console.log("close");
          this.getData();
        }, (reason) => {
          // on dismiss
          this.getData();
        });
      } else {
        swal("เพิ่มสิ่งปลูกร้างได้แค่ 1 หลังเท่านั้น");
      }
    } else {
      // const modalRef2 = this.modalService.open(BuildingModalComponent, { windowClass: 'fullscreen' });
      const modalRef2 = this.modalService.open(this.templateRefBuilding, { windowClass: 'fullscreen' });
      // console.log(this.ownerList);
      let building = new Building();
      building.annual = this.land.annual;
      building.oid = this.ownerList[0].landOwner.owner_id;
      building.moo = this.land.moo;
      building.village = this.land.community;
      building.ref_luid = this.landused.luid;
      building.ref_lid = this.land.lid;
      building.parcel_code = this.land.parcel_code;
      modalRef2.componentInstance.inputBuilding = building;

      modalRef2.result.then((data) => {
        // console.log("close");
        this.getData();
      }, (reason) => {
        // on dismiss
        this.getData();
      });
    }


  }

  editBuilding(event) {
    // const modalRef2 = this.modalService.open(BuildingModalComponent, { windowClass: 'fullscreen' });
    const modalRef2 = this.modalService.open(this.templateRefBuilding, { windowClass: 'fullscreen' });
    // console.log(this.ownerList);
    let building = new Building();
    building.bid = event['data'].bid;
    modalRef2.componentInstance.inputBuilding = building;

    modalRef2.result.then((data) => {
      console.log("close");
      this.getData();
    }, (reason) => {
      console.log("close");
      this.getData();
    });
  }

  saveLandused() {
    if (this.landused.luid != undefined) {
      this.http.requestPut('lands/lu/' + this.landused.luid, this.landused).subscribe(
        res => {
          swal('บันทึกการใช้ประโยชน์เรียบร้อยแล้ว');
          if (this.landused.lu_type != 2) {
            this.activeModal.close('Close click');
          }
          // this.landused = res;
        }
      );
    } else {
      this.http.requestPost('lands/lu', this.landused).subscribe(
        res => {
          swal('บันทึกการใช้ประโยชน์เรียบร้อยแล้ว');
          if (this.landused.lu_type != 2) {
            this.activeModal.close('Close click');

          }
          this.landused = res;

        }
      );
    }

  }

  remove() {
    if (this.landused.luid != undefined) {
      this.http.requestDelete('lands/lu/' + this.landused.luid).subscribe(
        res => {
          swal('ลบการใช้ประโยชน์เรียบร้อยแล้ว');
          this.activeModal.close('Close click');
        }
      );
    }
  }

  checkDuplicate(){
    //check API 
    if(this.landused.sub_lu_type == undefined){
      this.landused.sub_lu_type=0;
    }
    this.http.requestGet('land/check/lu/duplicate/'+this.landused.lid+'/'+this.landused.lu_type+'/'+this.landused.sub_lu_type).subscribe(
      res =>{
        if(res.luid !=this.landused.luid){
          swal("มีการใช้ประโยชน์ของที่ดินประเภทนี้อยู่แล้ว");
          swal({
            title: '',
            text: "มีการใช้ประโยชน์ของที่ดินประเภทนี้อยู่แล้ว ?",
            type: 'warning',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.value) {
              this.activeModal.close('Close click');
            }
          });
        }
      }
    );
  }

}
